$(document).on('turbolinks:load', function() {
  $('a.back-link').on('click', function(e) {
    e.preventDefault();
    window.history.back();
  });
});
